import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Box, useTheme } from "@mui/material";
import * as React from "react";

import {
  RobotoIconButton,
  RobotoTableCell,
  RobotoTooltip,
} from "@/shared/components";
import { FileSystemNode } from "@/shared/domain/files/filesystem";

interface ActionCellProps {
  row: FileSystemNode;
  handleMoreClicked: (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => void;
}

export const ActionCell: React.FC<ActionCellProps> = ({
  row,
  handleMoreClicked,
}) => {
  const theme = useTheme();

  return (
    <RobotoTableCell>
      <RobotoTooltip title={"View Operations"}>
        <Box sx={{ width: "fit-content", marginRight: theme.spacing(3) }}>
          <RobotoIconButton
            eventName={"FileSystemOperationsOptionsClicked"}
            eventProperties={{
              name: row.name,
            }}
            sx={{
              padding: 0,
              "&:hover": { bgcolor: "transparent" },
            }}
            onClick={handleMoreClicked}
          >
            <MoreHorizIcon fontSize="small" />
          </RobotoIconButton>
        </Box>
      </RobotoTooltip>
    </RobotoTableCell>
  );
};
